import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import {ActivatedRoute} from "@angular/router";
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username: string;
  password: string;
  errorMessage: string = null;

  constructor(private authService: AuthenticationService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    localStorage.clear();
    this.activatedRoute.params.subscribe(params => {
      this.errorMessage = params.msg || null;
    })
  }

  login() {
    this.errorMessage = null;

    if(_.isNil(this.username) || _.isNil(this.password)) {
      this.errorMessage = 'โปรดกรอกข้อมูลให้ครบถ้วน';
      return;
    }

    this.authService.login(this.username, this.password).subscribe(
      user => {
        let token = _.get(user, 'token');

        localStorage.clear();
        localStorage.setItem('currentUser', token);
        this.authService.updateUserInfo(user);

        if (token != null) {
          this.router.navigate(['']);
        }
      },
      error => {
        if(error != null && error.status == 400)
          this.errorMessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง';
        else
          this.errorMessage = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
      }
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.ts